import { render } from "./CompasSection.vue?vue&type=template&id=1427776b&ts=true"
import script from "./CompasSection.vue?vue&type=script&lang=ts"
export * from "./CompasSection.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__